/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionShootdown
 */
export interface InputUavMissionShootdown {
    /**
     * 
     * @type {string}
     * @memberof InputUavMissionShootdown
     */
    coords: string;
}

/**
 * Check if a given object implements the InputUavMissionShootdown interface.
 */
export function instanceOfInputUavMissionShootdown(value: object): boolean {
    if (!('coords' in value)) return false;
    return true;
}

export function InputUavMissionShootdownFromJSON(json: any): InputUavMissionShootdown {
    return InputUavMissionShootdownFromJSONTyped(json, false);
}

export function InputUavMissionShootdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionShootdown {
    if (json == null) {
        return json;
    }
    return {
        
        'coords': json['coords'],
    };
}

export function InputUavMissionShootdownToJSON(value?: InputUavMissionShootdown | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coords': value['coords'],
    };
}

